import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Button, Spin, Table} from 'antd';
import moment from 'moment';

import {Level} from '../../graphql/API';
import {LevelsService} from './LevelsService';
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';

const levelsService = new LevelsService();

export const LevelsTable = () => {
  const [levels, setLevels] = useState<Array<Level> | []>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    levelsService
      .getLevels()
      .then((resp) => {
        setIsLoading(false);
        setLevels(resp);
      })
      .catch((error) => {
        setIsError(true);
        //console.log('Error ->', error);
      });
  }, []);

  const columns: any = [
    {
      title: 'Name',
      dataIndex: ['name'],
      render: (name: string, record: Level) => (
        <Link to={'/levels/' + record.id + '/edit'}>{name}</Link>
      ),
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a: any, b: any) => {
        return a.name.localeCompare(b.name);
      },
    },
    {
      title: 'Score',
      dataIndex: 'score',
    },
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: (a: any, b: any) => a.id.length - b.id.length,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (id: string) => <Link to={'/levels/' + id + '/edit'}>{id}</Link>,
    },
  ];

  return (
    <>
      <Button size={'large'} style={{float: 'right', margin: 20}}>
        <Link to={'/levels/create'}>Create</Link>
      </Button>
      {!isError && !isLoading && (
        <Table
          pagination={{defaultPageSize: 100}}
          columns={columns}
          dataSource={levels}
        />
      )}
      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Levels fetching error ⚠️</Title>}
    </>
  );
};
